<template>
  <div class="position-actions">
    <c-button :id="`type-actions-${type.id}`" tabindex="-1" class="position-actions-button" size="iconic" icon="menu" />
    <b-popover placement="bottomleft" triggers="click" :target="`type-actions-${type.id}`">
      <div class="position-actions_menu">
        <div class="position-actions__menu-item" @click="$emit('edit')">
          <c-button class="position-actions__menu-item-icon" icon="edit" size="iconic" />
          <div class="position-actions__menu-item-label">Редактировать</div>
        </div>

        <div class="position-actions__menu-item" @click="$emit('archiveOperation')">
          <div class="position-actions__menu-item-icon">
            <svg
              v-if="!type.isArchive"
              width="15"
              height="14"
              viewBox="0 0 15 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 8H9M1 1H14V5H1V1ZM2 5H13V13H2V5Z"
                stroke="#8E9CBB"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg v-else width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 13C12.3137 13 15 10.3137 15 7C15 3.68629 12.3137 1 9 1C5.68629 1 3 3.68629 3 7M1 7L3 9L5 7"
                stroke="#8E9CBB"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="position-actions__menu-item-label">
            {{ !type.isArchive ? "Переместить в архив" : "Восстановить из архива" }}
          </div>
        </div>

        <div class="position-actions__menu-item" @click="$emit('remove')">
          <c-button class="position-actions__menu-item-icon" icon="trash" size="iconic" />
          <div class="position-actions__menu-item-label">Удалить</div>
        </div>
      </div>
    </b-popover>
  </div>
</template>
<script>
import Button from "@/components/controls2/Button";

export default {
  name: "position-actions",
  components: {
    "c-button": Button,
  },
  props: ["type"],

  created() {
    document.getElementsByTagName("body")[0].addEventListener("click", () => {
      this.$root.$emit("bv::hide::popover");
    });
  },
};
</script>
<style lang="scss" scoped>
.position-actions {
  &__menu {
    border-radius: 6px;
    margin: 0 -10px;

    &-item {
      display: flex;
      align-items: center;
      padding: 6px 33px 6px 15px;
      cursor: pointer;

      &-icon {
        width: 20px;
        height: 20px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-bottom: -2px;
        margin-left: -4px;
      }

      &-label {
        font-size: 15px;
        line-height: 17px;
        margin-left: 10px;
        overflow: hidden;

        &-bold {
          font-weight: 500;
        }
      }

      &:hover {
        background: #e1edff;
        border-radius: 50px;
      }
    }
  }
}
</style>
